import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { DateTime } from "luxon";
import CalendarIcon from "@material-ui/icons/Event";
import { notBlank } from "../../util/ext";

const useStyles = marginTop =>
  makeStyles(theme => ({
    root: {
      marginTop: marginTop,
    },

    input: {
      marginTop: 16,
    },
  }));

const DatePicker = props => {
  const {
    onChange,
    value,
    required = false,
    noLabel = false,
    label = "Publication Date",
    placeholder,
    disableToolbar = true,
    marginTop = 10,
  } = props;
  const classes = useStyles(marginTop)();

  return (
    <KeyboardDatePicker
      className={classes.root}
      InputProps={
        noLabel
          ? {
              classes: { root: classes.input },
            }
          : {}
      }
      margin="none"
      disableToolbar={disableToolbar}
      fullWidth
      autoOk
      required={required}
      minDate={new Date("01/01/1000")}
      variant="inline"
      format="MM/dd/yyyy"
      id="date-picker-inline"
      label={noLabel ? null : label}
      placeholder={placeholder}
      value={notBlank(value) ? DateTime.fromISO(value).setZone("utc") : null}
      onChange={onChange}
      keyboardIcon={<CalendarIcon fontSize="small" />}
      KeyboardButtonProps={{
        "aria-label": "change date",
      }}
    />
  );
};

export default DatePicker;
